import { Clock } from 'lucide-react'
import { StatusEnum, statusLabels } from '../../app/utils/status'
import { cn } from '../../app/utils/cn'
import { StatusCommission } from '@/app/utils/statusCommission'
import { ClassNameValue } from 'tailwind-merge'

interface StatusProps {
  status: StatusEnum | StatusCommission
  onlyIcon?: boolean
  className?: ClassNameValue
}
const statusDicionary = {
  [StatusEnum.PENDING]: {
    label: statusLabels[StatusEnum.PENDING],
    icon: <Clock size={14} />,
    style: 'text-info',
  },
  [StatusEnum.COMPLETED]: {
    label: statusLabels[StatusEnum.COMPLETED],
    icon: <i className="fa-solid fa-circle-check text-sm text-success" />,
    style: 'text-success',
  },
  [StatusEnum.REFUSED]: {
    label: statusLabels[StatusEnum.REFUSED],
    icon: <i className="fa-solid fa-circle-exclamation" />,
    style: 'text-error',
  },
  [StatusEnum.REFUNDED]: {
    label: statusLabels[StatusEnum.REFUNDED],
    icon: <i className="fa-solid fa-circle-exclamation" />,
    style: 'text-black04',
  },
  [StatusEnum.ACTION_REQUIRED]: {
    label: statusLabels[StatusEnum.ACTION_REQUIRED],
    icon: <i className="fa-solid fa-triangle-exclamation" />,
    style: 'text-warning',
  },
  [StatusCommission.AVAILABLE]: {
    label: 'Disponível',
    icon: <i className="fa-solid fa-circle-check text-sm text-success" />,
    style: 'text-success',
  },
  [StatusCommission.PAID]: {
    label: 'Pago',
    icon: <i className="fa-solid fa-circle-check text-sm text-success" />,
    style: 'text-success',
  },
  [StatusCommission.UNPAID]: {
    label: 'Recusado',
    icon: <i className="fa-solid fa-circle-exclamation" />,
    style: 'text-error',
  },
  [StatusEnum.FINALIZED]: {
    label: statusLabels[StatusEnum.FINALIZED],
    icon: <i className="fa-solid fa-circle-check text-sm text-success" />,
    style: 'text-success',
  },
}
export default function Status({
  status,
  onlyIcon = false,
  className,
}: StatusProps) {
  const { icon, label, style } = statusDicionary[status] || {}

  return (
    <div className="flex items-center justify-center">
      <div
        className={cn(
          'flex w-32 items-center justify-center gap-2 rounded-lg border-[1px] border-gray01 px-2 py-1',
          onlyIcon && 'w-fit',
          style,
          className,
        )}
      >
        {icon}
        {!onlyIcon && (
          <p className="text-center text-[10px] font-semibold">{label}</p>
        )}
      </div>
    </div>
  )
}
